import { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import RecoCard from '../../components/recommendations/RecoCard';
import useRecommendations from '../../utils/hook/useRecommendations';
// Vos hooks existants (déjà utilisés par la page de recherche) :
import useFavorites from '../../utils/hook/useFavorites';
import { useUser } from '../../utils/hook/UserContext';
import useSelection from '../../utils/hook/useSelection';

const parseDate = (v) => (v ? new Date(v) : null);

export default function RecommendationsPage() {
  const { user } = useUser();
  const [params] = useSearchParams();

  const start = useMemo(() => parseDate(params.get('start')), [params]);
  const end = useMemo(() => parseDate(params.get('end')), [params]);
  const lat = params.get('lat') ? Number(params.get('lat')) : undefined;
  const lng = params.get('lng') ? Number(params.get('lng')) : undefined;

  const { items, source, status, reload } = useRecommendations({ start, end, lat, lng });
  const { favoriteIds, toggleFavorite } = useFavorites();
  const { selectedIds, toggleSelect } = useSelection();

  return (
    <main className="container py-4">
      <header className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h1 className="h3 mb-1">
            <i className="bi bi-stars me-2" />
            Recommandé pour vous
          </h1>
          <p className="text-muted mb-0">
            Basé sur vos préférences, votre historique et la disponibilité.
          </p>
        </div>

        <div className="d-flex gap-2">
          <Link to="/preferences" className="btn btn-outline-secondary btn-sm">
            <i className="bi bi-sliders" /> Préférences
          </Link>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={reload}
            disabled={status === 'loading'}
          >
            <i className="bi bi-arrow-clockwise" /> Actualiser
          </button>
        </div>
      </header>

      {status === 'loading' && (
        <div className="d-grid gap-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="placeholder-glow">
              <div className="placeholder col-12 rounded-4" style={{ height: 220 }} />
            </div>
          ))}
        </div>
      )}

      {status === 'error' && (
        <div className="alert alert-danger d-flex justify-content-between align-items-center">
          Impossible de charger vos recommandations.
          <button className="btn btn-sm btn-danger" onClick={reload}>
            Réessayer
          </button>
        </div>
      )}

      {status === 'ready' && items.length === 0 && (
        <div className="text-center py-5">
          <p className="mb-3">Aucune annonce disponible pour le moment.</p>
          <Link to="/search" className="btn btn-primary">
            Explorer toutes les annonces
          </Link>
        </div>
      )}

      {status === 'ready' &&
        items.map((annonce) => (
          <RecoCard
            key={annonce.vehiculeAnnonceId}
            annonce={annonce}
            source={source}
            searchStart={start}
            searchEnd={end}
            currentUserId={user?.id}
            isSelected={selectedIds.has(annonce.vehiculeAnnonceId)}
            isFavorite={favoriteIds.has(annonce.vehiculeAnnonceId)}
            onToggleSelect={toggleSelect}
            onToggleFavorite={toggleFavorite}
          />
        ))}
    </main>
  );
}
